import React from 'react';
import { ArrowRight, Phone, CheckCircle } from 'lucide-react';
import { Button } from './ui/button';
import { companyInfo } from '../mock';

const Hero = () => {
  const scrollToSection = (href) => {
    const element = document.querySelector(href);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="home" className="relative min-h-screen flex items-center pt-32 pb-20 overflow-hidden">
      {/* Background with overlay */}
      <div className="absolute inset-0 z-0">
        <div className="absolute inset-0 bg-gradient-to-br from-[#1E40AF]/95 via-[#1E40AF]/90 to-[#2563EB]/85 z-10" />
        <img
          src="https://images.unsplash.com/photo-1686178827149-6d55c72d81df?w=1920&q=80"
          alt="Professional cleaning services"
          className="w-full h-full object-cover"
        />
      </div>

      {/* Content */}
      <div className="relative z-20 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 w-full">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Left content */}
          <div className="text-white space-y-8">
            <div className="inline-block">
              <span className="px-4 py-2 bg-white/20 backdrop-blur-md rounded-full text-sm font-medium border border-white/30">
                Ihr Partner in Feldkirchen bei Graz
              </span>
            </div>

            <h1 className="text-5xl lg:text-6xl font-bold leading-tight">
              Professionelle Hausbetreuung & Reinigungsdienste
            </h1>

            <p className="text-xl text-white/90 leading-relaxed">
              Ein frisch gegründetes Unternehmen mit bewährter Expertise – MC MaxClean OG 
              kombiniert langjährige Erfahrung mit innovativen Lösungen für Ihre Immobilie. 
              Professionell, zuverlässig und persönlich.
            </p>

            <div className="space-y-3">
              {[
                'Hausbetreuung & Immobilienpflege',
                'Schneeräumung & Reinigung von Verkehrsflächen',
                'Entrümpelung & Haushaltsauflösung'
              ].map((item, index) => (
                <div key={index} className="flex items-center gap-3">
                  <CheckCircle className="w-5 h-5 text-[#2563EB]" />
                  <span className="text-lg">{item}</span>
                </div>
              ))}
            </div>

            <div className="flex flex-col sm:flex-row gap-4 pt-4">
              <Button
                onClick={() => scrollToSection('#contact')}
                size="lg"
                className="bg-[#2563EB] hover:bg-[#6BA72F] text-white text-lg px-8 py-6 shadow-2xl group"
              >
                Kostenloses Angebot
                <ArrowRight className="ml-2 w-5 h-5 group-hover:translate-x-1 transition-transform" />
              </Button>
              <Button
                onClick={() => window.location.href = `tel:${companyInfo.phone}`}
                size="lg"
                variant="outline"
                className="bg-white/10 backdrop-blur-md border-white/30 text-white hover:bg-white/20 text-lg px-8 py-6"
              >
                <Phone className="mr-2 w-5 h-5" />
                Jetzt anrufen
              </Button>
            </div>
          </div>

          {/* Right content - Stats cards */}
          <div className="hidden lg:block">
            <div className="grid grid-cols-2 gap-6">
              {[
                { number: '2025', label: 'Neu gegründet' },
                { number: '10+', label: 'Jahre Erfahrung' },
                { number: '24/7', label: 'Notdienst' },
                { number: '100%', label: 'Engagement' }
              ].map((stat, index) => (
                <div
                  key={index}
                  className="bg-white/10 backdrop-blur-md border border-white/20 rounded-2xl p-6 hover:bg-white/15 transition-all duration-300 hover:scale-105"
                  style={{
                    animationDelay: `${index * 0.1}s`,
                    animation: 'fadeInUp 0.6s ease-out forwards'
                  }}
                >
                  <div className="text-4xl font-bold text-white mb-2">{stat.number}</div>
                  <div className="text-white/80 text-sm">{stat.label}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      {/* Decorative elements */}
      <div className="absolute bottom-0 left-0 right-0 h-32 bg-gradient-to-t from-white to-transparent z-20" />
    </section>
  );
};

export default Hero;
